import { type RefObject, useEffect, useRef } from 'react';

type UseClickToCloseRefProps = {
	handleClose: (
		event: Event | React.MouseEvent<Element, MouseEvent> | React.KeyboardEvent<Element> | null,
		currentLevel?: any,
	) => void;
	isOpen: boolean;
};

// TODO: Fill in the hook {description}.
/**
 * {description}.
 */
export function useClickToCloseRef({
	isOpen,
	handleClose,
}: UseClickToCloseRefProps): RefObject<HTMLElement> {
	const ref = useRef<HTMLElement>(null);

	useEffect(() => {
		const el = ref.current;

		if (!el) {
			return;
		}

		const clickListener = () => {
			if (isOpen) {
				handleClose(null);
			}
		};

		// eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
		el.addEventListener('click', clickListener);

		return () => {
			// eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
			el.removeEventListener('click', clickListener);
		};
	}, [isOpen, handleClose]);

	return ref;
}
